import * as types from './types'
// import { randomString } from 'helpers'
// import config from 'config';

const randomString = () => 'random'

const initialState = {
  name: '',
  content: [],
  progress: [],
  isFullscreen: false,
  courseLoaded: false,
  progressLoaded: false,
  checklist: {
    sections: [],
    sectionActiveIndex: -1,
    description: {},
  },
  quiz: {
    retake: false,
    questions: [],
    activeIndex: -1,
    randomizeOrder: false,
    quizStatus: 0,
    quizPassPercentage: 80,
    quizTimer: 0,
    questionsPerDaysValue: 0,
    daysPerQuestionsValue: 0,
    quizStartDate: null,
    isPassPercentageActive: false,
    isQuizTimerActive: false,
    isQuizExpirationActive: false,
  },
  contentQuiz: {
    title: '',
    index: 0,
    questions: [],
    activeIndex: -1,
    randomizeOrder: false,
    quizPassPercentage: 70,
    quizTimer: 0,
    isPassPercentageActive: false,
    isQuizTimerActive: false,
    passable: false,
  },
  currentContentQuiz: {},
  retryCurrentContentQuiz: {},
  submitedContentQuiz: null,
  contentQuizId: null,
  previousContentQuiz: null,
  previousQuiz: null,
  showUploadVideoPage: false,
  videoActiveIndex: -1,
  uploadVideoStatus: '',
  fileActiveIndex: -1,
  showUploadFilePage: false,
  thumbFile: null,
  thumbValue: null,
  description: '',
  promote: 0,
  uploadVideoPercent: 0,
  uploadFilePercent: 0,
  scormActiveIndex: -1,
  uploadScormStatus: '',
  uploadScormPercent: 0,
  showUploadScormPage: false,
  videoType: '',
  containerPosition: [],
  currentTab: 'timeline',
  currentTabViewCourse: 'lessons',
  textContent: '',
  categoryId: '',
  courses: [],
  fetchedAllCourses: false,
  allCourses: [],
  userProgress: [],
  searchValue: '',
  searchValueComments: '',
  searchValueOnClick: '',
  tracking: [],
  containersLoaded: false,
  selectedGroups: [],
  html: '',
  cloneId: null,
  newTextContent: '',
  requiredContent: true,
  restricVideo: false,
  finishedContent: [],
  filteredRequiredContent: [],
  statuses: [],
  selectedStatuses: [],
  userGroups: [],
  groupStatus: [],
  manageableCourses: [],
  redirectUrl: '',
  certificateFooterContent: '',
  certificateShowing: false,
  feedbackShowing: false,
  feedbackRatingHide: false,
  quizAttemptsAllowed: null,
  title: '',
  language: 1,
  courseAvailableLanguages: [],
  availableLanguagesOptions: [],
  languageIsReady: 1,
  isDefaultCourse: 1,
  equivalentCourse: null,
  keywords: [],
  availableKeywords: [],
  inactive: false,
  secondLevelApproval: 0,
  checklistType: 1,
  currentCourse: null,
  selectedCourse: null,
  selectedContent: null,
  existingContents: [],
  items: [],
  pageOfItems: [],
  searchValueExistingContent: '',
  rewardPoints: null,
  enrollmentType: 0,
  enrollmentPeriodType: 0,
  enrollmentPeriod: null,
  price: 9.99,
  newAccessCode: '',
  rewardOverlayShowing: false,
  earnedRewardsBadges: [],
  earnedRewardsPoints: null,
  launchUrl: '',
  consumerKey: '',
  sharedSecret: '',
  customParameters: '',
  params: null,
  selfAssignable: 0,
  allowPublicAccess: 0,
  enableCompletionFeedback: 0,
  requireAgreement: 0,
  remindUsers: 0,
  emailFrequency: null,
  dontShowOnManagerReport: 0,
  hideCourseSidebar: 0,
  doNotShowCertificate: 0,
  disablePdfDownload: 0,
  allowCourseFeedback: 0,
  allowCourseComments: 0,
  setExpirationDate: 0,
  setChangeExpirationDate: 0,
  rewatchedVideo: null,
  suspendData: {},
  feedbackData: {},
  ratingData: 0,
  averageRating: 0,
  selfCourseFeedbackData: null,
  courseNote: null,
  isFeedbackOverlayShowing: false,
  courseRatingData: null,
  training: {},
  topic: '',
  trDescription: '',
  date: '',
  time: '',
  trainingPeriod: '',
  durationHour: '',
  durationMin: '',
  timezone: '',
  zoomStartUrl: '',
  zoomJoinUrl: '',
  isFeedbackTextboxActive: false,
  isNewCommentActive: false,
  courseComments: [],
  courseComment: '',
  courseCommentReply: '',
  isEditTextboxActive: false,
  isReplyTextboxActive: false,
  currentComment: null,
  currentReply: null,
  isLoadingComments: false,
  isNewCommentDisabled: false,
  isReplyCommentDisabled: false,
  isEditCommentDisabled: false,
  trainingType: '',
  trainingThumb: '',
  selectedStoresTraining: [],
  externalTrainingInstructors: [{ id: randomString(), name: '' }],
  selectedInternalTrainingInstructors: [],
  assignExpanded: false,
  remainingSeats: 0,
  originalName: '',
  isTrainingLoading: false,
  courseGroups: null,
  coursesViewPermission: new Map(),
  inViewCourse: false,
  contentLoading: false,
  expirePeriod: 'd',
  expireDate: null,
  expiration_date: '',
  iFrameKey: 0,
  lastPathname: '',
  allLanguagesPromoted: null,
  resettingProgress: false,
  tableData: [
    ['', ''],
    ['', ''],
    ['', ''],
  ],
  hasGivenFeedBack: false,
  hasCompletedTerms: false,
}

const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ID:
      return {
        ...state,
        ...action.data,
        quiz: state.quiz,
        checklist: state.checklist,
      }
    case types.SET_RESETTING_PROGRESS:
      return {
        ...state,
        resettingProgress: action.payload,
      }
    case types.SET_FULLSCREEN:
      return {
        ...state,
        isFullscreen: action.isFullscreen,
      }
    case types.SET_LAST_PATHNAME:
      return {
        ...state,
        lastPathname: action.payload,
      }
    case types.COURSE:
      return {
        ...state,
        ...action.data,
        quiz: {
          ...state.quiz,
          ...action.data.quiz,
        },
        checklist: {
          ...state.checklist,
          ...action.data.checklist,
        },
        categoryId: action.data.category_id,
        redirectUrl: action.data.redirect_url,
        certificateFooterContent: action.data.certificate_footer_content,
        quizAttemptsAllowed: action.data.quiz_attempts_allowed,
        languageIsReady: action.data.is_ready,
        language: action.data.language_id,
        isDefaultCourse: action.data.is_default_course,
        equivalentCourse: action.data.equivalent_id,
        rewardPoints: action.data.reward_points,
        enrollmentType: action.data.enrollment_type,
        enrollmentPeriodType: action.data.enrollment_period_type,
        enrollmentPeriod: action.data.enrollment_period,
        price: action.data.price,
        inactive: action.data.is_active === 1 ? false : true,
        secondLevelApproval: action.data.require_approval === 1 ? true : false,
        checklistType: action.data.checklist_type === 2 ? 2 : 1,
        allKeywords: [],
        keywords: action.data.keywords ? action.data.keywords : [],
        selfAssignable: action.data.self_assignable
          ? action.data.self_assignable
          : 0,
        allowPublicAccess: action.data.allow_public_access
          ? action.data.allow_public_access
          : 0,
        enableCompletionFeedback: action.data.enable_completion_feedback
          ? action.data.enable_completion_feedback
          : 0,
        requireAgreement: action.data.require_agreement
          ? action.data.require_agreement
          : 0,
        remindUsers: action.data.remind_users ? action.data.remind_users : 0,
        emailFrequency: action.data.email_frequency || null,
        dontShowOnManagerReport: action.data.dont_show_on_manager_report
          ? action.data.dont_show_on_manager_report
          : 0,
        hideCourseSidebar: action.data.hide_course_sidebar
          ? action.data.hide_course_sidebar
          : 0,
        doNotShowCertificate: action.data.do_not_show_certificate
          ? action.data.do_not_show_certificate
          : 0,
        disablePdfDownload: action.data.disable_pdf_download
          ? action.data.disable_pdf_download
          : 0,
        allowCourseFeedback: action.data.allow_course_feedback
          ? action.data.allow_course_feedback
          : 0,
        allowCourseComments: action.data.allow_comments
          ? action.data.allow_comments
          : 0,
        setExpirationDate:
          action.data.allow_expiration_date == 1 ? true : false,
        expiration_date:
          action.data.expiration_date && action.data.expiration_date.length
            ? action.data.expiration_date
            : '',
      }
    case types.LIST:
      return {
        ...state,
        list: action.data,
      }
    case types.PROGRESS:
      return {
        ...state,
        progress: action.data,
      }
    case types.LOADING:
      return {
        ...state,
        [action.loadingType]: action.isLoading,
      }
    case types.ON_CHANGE:
      return {
        ...state,
        [action.name]: action.value,
      }
    case types.SET_EMAIL_FREQUENCY:
      return {
        ...state,
        emailFrequency: action.value,
      }
    case types.ON_CHANGE_ZOOM:
      return {
        ...state,
        [action.name]: action.value,
      }
    case types.ON_CHANGE_TRAINING_FORM:
      return {
        ...state,
        training: {
          ...state.training,
          [action.name]: action.value,
        },
      }
    case types.INCREASE_IFRAME_KEY:
      return {
        ...state,
        iFrameKey: state.iFrameKey + 1,
      }
    case types.SET_EXPIRATION_DATE:
      return {
        ...state,
        setExpirationDate: !state.setExpirationDate,
        setChangeExpirationDate: !state.setChangeExpirationDate,
      }

    case types.RESET_EXPIRATION_DATE:
      return {
        ...state,
        setChangeExpirationDate: 0,
        expireDate: null,
      }
    case types.SET_CHANGE_EXPIRATION_DATE:
      return {
        ...state,
        setChangeExpirationDate: !state.setChangeExpirationDate,
      }
    case types.START_URL:
      return {
        ...state,
        zoomStartUrl: action.value,
      }
    case types.JOIN_URL:
      return {
        ...state,
        zoomJoinUrl: action.value,
      }
    case types.ON_CHANGE_QUESTION:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          questions: action.questions,
        },
      }
    case types.QUESTION_ACTIVE_INDEX:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          activeIndex: action.activeIndex,
        },
      }
    case types.CLOSE_QUIZ_MODAL:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          activeIndex: -1,
        },
      }
    case types.UNDO:
      return {
        ...state,
        quiz: state.previousQuiz && JSON.parse(state.previousQuiz),
        checklist:
          state.previousChecklist && JSON.parse(state.previousChecklist),
        content: state.previousContent && JSON.parse(state.previousContent),
        previousQuiz: null,
      }
    case types.PRESENT:
      return {
        ...state,
        previousQuiz: JSON.stringify(state.quiz),
        previousChecklist: JSON.stringify(state.checklist),
        previousContent: JSON.stringify(state.content),
      }
    case types.SET_CONTENT_QUIZ_PASS_PERCENTAGE:
      return {
        ...state,
        contentQuiz: {
          ...state.contentQuiz,
          quizPassPercentage: action.value,
        },
      }
    case types.TOGGLE_CONTENT_QUIZ_PASS_PERCENTAGE:
      return {
        ...state,
        contentQuiz: {
          ...state.contentQuiz,
          isPassPercentageActive: !state.contentQuiz.isPassPercentageActive,
        },
      }
    case types.SET_COUNT_CONTENT_QUIZ:
      return {
        ...state,
        contentQuiz: {
          ...state.contentQuiz,
          quizTimer: action.value,
        },
      }
    case types.TOGGLE_CONTENT_QUIZ_TIMER:
      return {
        ...state,
        contentQuiz: {
          ...state.contentQuiz,
          isQuizTimerActive: !state.contentQuiz.isQuizTimerActive,
        },
      }
    case types.TOGGLE_CONTENT_QUIZ_RANDOMIZE_ORDER:
      return {
        ...state,
        contentQuiz: {
          ...state.contentQuiz,
          randomizeOrder: !state.contentQuiz.randomizeOrder,
        },
      }
    case types.ON_CHANGE_CONTENT_QUESTION:
      return {
        ...state,
        contentQuiz: {
          ...state.contentQuiz,
          questions: action.questions,
        },
      }

    case types.SET_EXPIRE_PERIOD:
      return {
        ...state,
        expirePeriod: action.value,
      }
    case types.SET_EXPIRE_DATE:
      return {
        ...state,
        expireDate: action.value,
      }
    case types.SET_ACTIVE_EXPIRATION_DATE:
      return {
        ...state,
        expiration_date: action.value,
      }
    case types.SET_CONTENT_QUESTION_ACTIVE_INDEX:
      return {
        ...state,
        contentQuiz: {
          ...state.contentQuiz,
          activeIndex: action.activeIndex,
        },
      }
    case types.SET_CURRENT_CONTENT_QUIZ:
      return {
        ...state,
        currentContentQuiz: action.quiz,
      }
    case types.ANSWER:
      return {
        ...state,
        currentContentQuiz: {
          ...state.currentContentQuiz,
          questions: action.questions,
        },
      }
    case types.ACTIVE_QUESTION:
      return {
        ...state,
        currentContentQuiz: {
          ...state.currentContentQuiz,
          index: action.index,
        },
      }

    case types.SET_CONTENT_QUIZ_ID:
      return {
        ...state,
        contentQuizId: action.payload,
      }
    case types.SET_SUBMITED_CONTENT_QUIZ:
      return {
        ...state,
        submitedContentQuiz: action.payload,
      }

    case types.SET_CONTENT_QUIZ_NAME:
      return {
        ...state,
        contentQuiz: {
          ...state.contentQuiz,
          title: action.name,
        },
      }
    case types.TOGGLE_CONTENT_QUIZ_PASSABLE:
      return {
        ...state,
        contentQuiz: {
          ...state.contentQuiz,
          passable: !state.contentQuiz.passable,
        },
      }

    case types.SET_NEW_CONTENT_QUIZ:
      return {
        ...state,
        contentQuiz: action.payload,
      }
    case types.SET_CONTENT_QUIZ_EDITING:
      return {
        ...state,
        contentQuiz: action.payload,
      }
    case types.SET_CONTENT_QUIZ_ID:
      return {
        ...state,
        contentQuizId: action.payload,
      }
    case types.SET_CONTENT_QUESTION_ACTIVE_INDEX:
      return {
        ...state,
        contentQuiz: {
          ...state.contentQuiz,
          activeIndex: action.activeIndex,
        },
      }
    case types.UNDO_CONTENT_QUIZ:
      return {
        ...state,
        contentQuiz:
          state.previousContentQuiz && JSON.parse(state.previousContentQuiz),
      }
    case types.PRESENT_CONTENT_QUIZ:
      return {
        ...state,
        previousContentQuiz: JSON.stringify(state.contentQuiz),
      }
    case types.SET_RETRY_CURRENT_CONTENT_QUIZ:
      return {
        ...state,
        retryCurrentContentQuiz: action.quiz,
      }
    case types.RESET:
      return {
        ...state,
        name: '',
        id: null,
        thumbFile: null,
        thumbValue: null,
        course_id: null,
        description: '',
        textContent: '',
        courseLoaded: false,
        containersLoaded: false,
        categoryId: initialState.categoryId,
        videoType: initialState.videoType,
        containerPosition: initialState.containerPosition,
        videoUploadPercent: initialState.videoUploadPercent,
        promote: initialState.promote,
        quiz: initialState.quiz,
        checklist: initialState.checklist,
        content: initialState.content,
        redirectUrl: '',
        certificateFooterContent: '',
        courseAvailableLanguages: [],
        availableLanguagesOptions: [],
        equivalentCourse: initialState.equivalentCourse,
        languageIsReady: initialState.languageIsReady,
        inactive: initialState.inactive,
        secondLevelApproval: initialState.secondLevelApproval,
        checklistType: initialState.checklistType,
        isDefaultCourse: initialState.isDefaultCourse,
        selectedCourse: initialState.selectedCourse,
        keywords: initialState.keywords,
        rewardPoints: null,
        enrollmentType: 0,
        enrollmentPeriodType: 0,
        enrollmentPeriod: null,
        price: 9.99,
        newAccessCode: '',
        selfAssignable: initialState.selfAssignable,
        allowPublicAccess: initialState.allowPublicAccess,
        enableCompletionFeedback: initialState.enableCompletionFeedback,
        requireAgreement: initialState.requireAgreement,
        remindUsers: initialState.remindUsers,
        emailFrequency: initialState.emailFrequency,
        dontShowOnManagerReport: initialState.dontShowOnManagerReport,
        hideCourseSidebar: initialState.hideCourseSidebar,
        doNotShowCertificate: initialState.doNotShowCertificate,
        disablePdfDownload: initialState.disablePdfDownload,
        allowCourseFeedback: initialState.allowCourseFeedback,
        allowCourseComments: initialState.allowCourseComments,
        courseGroups: null,
        currentTab: 'timeline',
        setExpirationDate: initialState.setExpirationDate,
      }
    case types.TOGGLE_UPLOAD_PAGE:
      return {
        ...state,
        showUploadVideoPage: action.mode,
      }
    case types.TOGGLE_UPLOAD_FILE_PAGE:
      return {
        ...state,
        showUploadFilePage: action.mode,
      }
    case types.EDIT_VIDEO:
      return {
        ...state,
        videoActiveIndex: action.index,
      }
    case types.EDIT_FILE:
      return {
        ...state,
        fileActiveIndex: action.index,
      }
    case types.UPLOAD_FILE_STATUS:
      return {
        ...state,
        uploadFileStatus: action.status,
      }
    case types.UPLOAD_VIDEO_STATUS:
      return {
        ...state,
        uploadVideoStatus: action.status,
      }
    case types.UPDATE_FILE:
    case types.UPDATE_VIDEO:
    case types.UPDATE_SCORM:
    case types.UPDATE_TEXT:
      return {
        ...state,
        content: action.content,
      }
    case types.ADD_SECTION:
      return {
        ...state,
        checklist: {
          ...state.checklist,
          sections: action.sections,
        },
      }
    case types.UPDATE_DESCRIPTION:
      return {
        ...state,
        checklist: {
          ...state.checklist,
          [action.name]: action.value,
        },
      }
    case types.SECTION_ACTIVE_INDEX:
      return {
        ...state,
        checklist: {
          ...state.checklist,
          sectionActiveIndex: action.index,
        },
      }
    case types.COURSE_THUMBNAIL:
      return {
        ...state,
        thumbValue: action.thumbValue,
      }
    case types.COURSE_THUMBNAIL_FILE:
      return {
        ...state,
        thumbFile: action.thumbFile,
      }
    case types.COURSE_CREATE:
      return {
        ...state,
        createCourseLoading: action.isLoading,
      }
    case types.VIDEO_UPLOAD_PERCENT:
      return {
        ...state,
        uploadVideoPercent: action.percent,
      }
    case types.FILE_UPLOAD_PERCENT:
      return {
        ...state,
        uploadFilePercent: action.percent,
      }
    case types.SET_IMAGE:
      return {
        ...state,
        image: action.image,
      }
    case types.UPLOAD_SCORM_STATUS:
      return {
        ...state,
        uploadScormStatus: action.status,
      }
    case types.UPLOAD_SCORM_PERCENT:
      return {
        ...state,
        uploadScormPercent: action.percent,
      }
    case types.TOGGLE_UPLOAD_SCORM_PAGE:
      return {
        ...state,
        showUploadScormPage: action.mode,
      }
    case types.EDIT_SCORM:
      return {
        ...state,
        scormActiveIndex: action.index,
      }
    case types.SELECT_VIDEO_TYPE:
      return {
        ...state,
        videoType: action.value,
      }
    case types.REORDER_CONTAINERS:
      return {
        ...state,
        containerPosition: action.containers,
      }
    case types.SET_CURRENT_TAB:
      return {
        ...state,
        currentTab: action.tab,
      }
    case types.SET_CURRENT_TAB_VIEW_COURSE:
      return {
        ...state,
        currentTabViewCourse: action.tab,
      }
    case types.SET_TEXT_CONTENT:
      return {
        ...state,
        textContent: action.value,
      }
    case types.SET_NEW_TEXT_CONTENT:
      return {
        ...state,
        newTextContent: action.value,
      }
    case types.COURSE_ALL:
      return {
        ...state,
        courses: action.data,
      }
    case types.SET_FETCHED_ALL_COURSES:
      return {
        ...state,
        fetchedAllCourses: action.payload,
      }
    case types.SET_ALL_COURSES:
      return {
        ...state,
        allCourses: action.data,
      }
    case types.SET_USER_PROGRESS:
      return {
        ...state,
        userProgress: action.data,
      }
    case types.SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.value,
      }
    case types.SET_SEARCH_VALUE_ON_CLICK:
      return {
        ...state,
        searchValueOnClick: action.value,
      }
    case types.SET_TRACKING_DATA:
      return {
        ...state,
        tracking: action.data,
      }
    case types.SET_TRACKING_DATA_REWATCH:
      return {
        ...state,
        rewatchedVideo: action.data,
      }
    case types.COURSE_LOADED:
      return {
        ...state,
        courseLoaded: true,
      }
    case types.CONTAINERS_LOADED:
      return {
        ...state,
        containersLoaded: true,
      }
    case types.SET_CONTENTS_LOADING:
      return {
        ...state,
        contentLoading: action.contentLoading,
      }
    case types.SET_CONTENTS:
      return {
        ...state,
        content: action.data,
      }
    case types.SET_SUBMISSIONS:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          questions: action.questions,
        },
      }
    case types.SLECT_COURSE_GROUPS:
      return {
        ...state,
        selectedGroups: action.groups,
      }
    case types.REORDER_QUIZZES:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          questions: action.questions,
        },
      }
    case types.MANAGE_HTML:
      return {
        ...state,
        html: action.html,
      }
    case types.SET_HTML_CONTENT:
      return {
        ...state,
        html: action.value,
      }
    case types.TOGGLE_QUIZ_RETAKE:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          retake: !state.quiz.retake,
        },
      }
    case types.TOGGLE_PASS_PERCENTAGE:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          isPassPercentageActive: !state.quiz.isPassPercentageActive,
        },
      }
    case types.TOGGLE_QUIZ_TIMER:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          isQuizTimerActive: !state.quiz.isQuizTimerActive,
        },
      }
    case types.TOGGLE_QUIZ_EXPIRATION:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          isQuizExpirationActive: !state.quiz.isQuizExpirationActive,
        },
      }
    case types.SET_QUIZ_PASS_PERCENTAGE:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          quizPassPercentage: action.value,
        },
      }
    case types.SET_COUNT:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          quizTimer: action.value,
        },
      }
    case types.SET_QUESTIONS_PER_DAYS:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          questionsPerDaysValue: action.value,
        },
      }
    case types.SET_DAYS_PER_QUESTIONS:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          daysPerQuestionsValue: action.value,
        },
      }
    case types.SET_QUIZ_START_DATE:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          quizStartDate: action.quizStartDate,
        },
      }
    case types.TOGGLE_QUIZ_RANDOMIZE_ORDER:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          randomizeOrder: !state.quiz.randomizeOrder,
        },
      }

    case types.SET_CLONE_ID:
      return {
        ...state,
        cloneId: action.id,
      }

    case types.SET_COURSE_LANGUAGE:
      return {
        ...state,
        language: action.language,
        quiz: {
          retake: true,
          questions: [],
          activeIndex: -1,
          randomizeOrder: false,
          quizStatus: 0,
        },
      }

    case types.UPDATE_CONTENT:
      return {
        ...state,
        content: action.newContent,
      }
    case types.SET_REQUIRED_CONTENT:
      return {
        ...state,
        content: action.newContent,
      }
    case types.SET_REQUIRED:
      return {
        ...state,
        requiredContent: action.requiredContent,
      }
    case types.SET_RESTRICT_VIDEO:
      return {
        ...state,
        restricVideo: action.payload,
      }
    case types.SET_FINISHED_CONTENT:
      return {
        ...state,
        finishedContent: action.finishedContent,
      }
    case types.SET_CONTENT_REQUIRED:
      return {
        ...state,
        filteredRequiredContent: action.filteredRequiredContent,
      }
    case types.SET_STATUSES:
      return {
        ...state,
        statuses: action.statuses,
      }
    case types.SET_SELECTED_STATUESES:
      return {
        ...state,
        selectedStatuses: action.statuses,
      }
    case types.SET_USER_GROUPS:
      return {
        ...state,
        userGroups: action.userGroups,
      }
    case types.SET_USER_GROUPS_COURSES:
      return {
        ...state,
        userGroupsCourses: action.userGroupsCourses,
      }
    case types.SET_GROUP_COURSES_STATUS:
      return {
        ...state,
        groupStatus: action.groupStatus,
      }
    case types.SET_MANAGEABLE_COURSES:
      return {
        ...state,
        manageableCourses: action.manageableCourses,
      }
    case types.SET_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: action.value,
      }
    case types.SET_CERTIFICATE_FOOTER_CONTENT:
      return {
        ...state,
        certificateFooterContent: action.value,
      }
    case types.SET_SHOW_CERTIFICATE:
      return {
        ...state,
        certificateShowing: true,
      }
    case types.SET_HIDE_CERTIFICATE:
      return {
        ...state,
        certificateShowing: false,
      }
    case types.SET_SHOW_FEEDBACK:
      return {
        ...state,

        feedbackShowing: !state.feedbackShowing,
      }
    case types.SET_HIDE_FEEDBACK:
      return {
        ...state,
        feedbackShowing: false,
      }
    case types.SET_HIDE_FEEDBACKRATING:
      return {
        ...state,
        feedbackRatingHide: action.value,
      }

    case types.SET_RETAKE_QUIZ_COUNT:
      return {
        ...state,
        quizAttemptsAllowed: action.value,
      }
    case types.SET_TEXT_TITLE:
      return {
        ...state,
        title: action.title,
      }
    case types.SET_COURSE_AVAILABLE_LANGUAGES:
      return {
        ...state,
        courseAvailableLanguages: action.value,
      }
    case types.SET_AVAILABLE_LANGUAGES_OPTIONS:
      return {
        ...state,
        availableLanguagesOptions: action.value,
      }
    case types.SET_LANGUAGE_READY:
      return {
        ...state,
        languageIsReady: action.value,
      }
    case types.SET_EQUIVALENT_COURSE:
      return {
        ...state,
        equivalentCourse: action.value,
      }
    case types.SET_KEYWORDS:
      return {
        ...state,
        keywords: action.value,
      }
    case types.SET_AVAILABLE_KEYWORDS:
      return {
        ...state,
        availableKeywords: action.value,
      }
    case types.SET_COURSE_INACTIVE:
      return {
        ...state,
        inactive: !state.inactive,
      }
    case types.SET_SECOND_LEVEL_APPROVAL:
      return {
        ...state,
        secondLevelApproval: !state.secondLevelApproval,
      }
    case types.SET_CHECKLIST_TYPE:
      return {
        ...state,
        checklistType: state.checklistType === 1 ? 2 : 1,
      }
    case types.SET_CURRENT_COURSE:
      return {
        ...state,
        currentCourse: action.data,
      }
    case types.SELECT_COURSE:
      return {
        ...state,
        selectedCourse: action.course,
      }
    case types.SELECT_CONTENT:
      return {
        ...state,
        selectedContent: action.content,
      }
    case types.SET_COURSE_EXISTING_CONTENT:
      return {
        ...state,
        existingContents: action.filterData,
      }
    case types.SET_ITEMS:
      return {
        ...state,
        items: action.items,
      }
    case types.SET_PAGE_OF_ITEMS:
      return {
        ...state,
        pageOfItems: action.pageOfItems,
      }
    case types.SET_SEARCH_VALUE_EXISTING_CONTENT:
      return {
        ...state,
        searchValueExistingContent: action.value,
      }
    case types.SET_SHOW_CLAIM_REWARD:
      return {
        ...state,
        rewardOverlayShowing: true,
      }
    case types.SET_HIDE_CLAIM_REWARD:
      return {
        ...state,
        rewardOverlayShowing: false,
      }
    case types.SET_EARNED_REWARDS_BADGES:
      return {
        ...state,
        earnedRewardsBadges: action.data,
      }
    case types.SET_EARNED_REWARDS_POINTS:
      return {
        ...state,
        earnedRewardsPoints: action.data,
      }
    case types.SET_LTI_DATA:
      return {
        ...state,
        ...state.ltiData,
        [action.name]: action.value,
      }
    case types.SET_LAUNCH_URL:
      return {
        ...state,
        launchUrl: action.launchUrl,
      }
    case types.SET_CONSUMER_KEY:
      return {
        ...state,
        consumerKey: action.consumerKey,
      }
    case types.SET_CONSUMER_SECRET:
      return {
        ...state,
        sharedSecret: action.sharedSecret,
      }
    case types.SET_CUSTOM_PARAMETERS:
      return {
        ...state,
        customParameters: action.customParameters,
      }
    case types.SET_LTI_PARAMS:
      return {
        ...state,
        params: action.params,
      }
    case types.RESET_LTI_FIELDS:
      return {
        ...state,
        title: '',
        launchUrl: '',
        consumerKey: '',
        sharedSecret: '',
        customParameters: '',
      }
    case types.SET_SUSPEND_DATA:
      return {
        ...state,
        suspendData: action.suspendData,
      }
    case types.SET_FEEDBACK_DATA:
      return {
        ...state,
        feedbackData: action.feedbackData,
      }
    case types.SET_SELF_COURSE_FEEDBACK_DATA:
      return {
        ...state,
        selfCourseFeedbackData: action.selfCourseFeedbackData,
      }
    case types.SET_RATING_DATA:
      return {
        ...state,
        averageRating: action.value,
      }
    case types.SET_COURSE_NOTE:
      return {
        ...state,
        courseNote: action.value,
      }
    case types.FETCH_COURSE_NOTE:
      return {
        ...state,
        courseNote: action.data,
      }
    case types.TOOGLE_FEEDBACK_OVERLAY:
      return {
        ...state,
        isFeedbackOverlayShowing: action.value,
      }
    case types.FETCH_COURSE_RATING:
      return {
        ...state,
        courseRatingData: action.data,
      }
    case types.SET_FEEDBACK_TEXTBOX_ACTIVE:
      return {
        ...state,
        isFeedbackTextboxActive: action.value,
      }
    case types.SET_COURSE_COMMENTS:
      return {
        ...state,
        courseComments: action.data,
      }
    case types.SET_COURSE_COMMENT:
      return {
        ...state,
        courseComment: action.value,
      }
    case types.SET_COURSE_COMMENT_REPLY:
      return {
        ...state,
        courseCommentReply: action.value,
      }
    case types.SET_NEW_COMMENT_ACTIVE:
      return {
        ...state,
        isNewCommentActive: action.value,
      }
    case types.SET_SEARCH_VALUE_COMMENTS:
      return {
        ...state,
        searchValueComments: action.searchValueComments,
      }
    case types.SET_EDIT_TEXTBOX_ACTIVE:
      return {
        ...state,
        isEditTextboxActive: action.isEditTextboxActive,
      }
    case types.SET_REPLY_TEXTBOX_ACTIVE:
      return {
        ...state,
        isReplyTextboxActive: action.isReplyTextboxActive,
      }
    case types.SET_LOADING_COMMENTS:
      return {
        ...state,
        isLoadingComments: action.isLoadingComments,
      }
    case types.SET_CURRENT_COMMENT:
      return {
        ...state,
        currentComment: action.value,
      }
    case types.SET_CURRENT_REPLY:
      return {
        ...state,
        currentReply: action.value,
      }
    case types.SET_NEW_COMMENT_DISABLED:
      return {
        ...state,
        isNewCommentDisabled: action.value,
      }
    case types.SET_REPLY_COMMENT_DISABLED:
      return {
        ...state,
        isReplyCommentDisabled: action.value,
      }
    case types.SET_EDIT_COMMENT_DISABLED:
      return {
        ...state,
        isEditCommentDisabled: action.value,
      }
    case types.ON_CHANGE_TRAINING_TYPE:
      return {
        ...state,
        trainingType: action.trainingType,
      }
    case types.SELECT_STORES:
      return {
        ...state,
        selectedStoresTraining: action.selectedStoresTraining,
      }
    case types.SET_TRAINING_INTRUCTORS:
      return {
        ...state,
        externalTrainingInstructors: action.externalTrainingInstructors,
      }
    case types.SELECT_USERS:
      return {
        ...state,
        selectedInternalTrainingInstructors:
          action.selectedInternalTrainingInstructors,
      }
    case types.SET_ASSIGN_EXPANDED:
      return {
        ...state,
        assignExpanded: action.assignExpanded,
      }
    case types.SET_LOADING_TRAINING:
      return {
        ...state,
        isTrainingLoading: action.value,
      }
    case types.TRAINING_THUMBNAIL:
      return {
        ...state,
        trainingThumb: action.trainingThumb,
        originalName: action.originalName,
      }
    case types.SET_TRAINING_DATA:
      return {
        ...state,
        training: {
          ...state.training,
          trainingId: action.value && action.value.id,
          topic: action.value && action.value.topic,
          trDescription: action.value && action.value.description,
          date:
            action.value &&
            action.value.time &&
            action.value.time.split('T')[0],
          time:
            action.value &&
            action.value.time &&
            action.value.time.split('T')[1],
          duration: action.value && action.value.duration,
          durationHour: Math.trunc(action.value && action.value.duration / 60),
          durationMin: action.value && action.value.duration % 60,
          timezone: action.value && action.value.timezone,
          availableSeats: action.value && action.value.available_seats,
          address: action.value && action.value.address,
          trainingThumb: action.value && action.value.image,
          trainingInstructors: action.trainers && action.trainers,
          remainingSeats: action.remainingSeats && action.remainingSeats,
        },
      }
    case types.RESET_TRAINING_DATA:
      return {
        ...state,
        topic: '',
        date: '',
        time: '',
        durationHour: '',
        durationMin: '',
        timezone: '',
        trDescription: '',
        training: {
          ...state.training,
          trainingId: '',
          topic: '',
          trDescription: '',
          date: '',
          time: '',
          duration: '',
          durationHour: '',
          durationMin: '',
          timezone: '',
          availableSeats: '',
          address: '',
          trainingThumb: '',
          trainingInstructors: '',
          remainingSeats: '',
        },
      }
    case types.SET_COURSES_VIEW_PERMISSION:
      return {
        ...state,
        coursesViewPermission: action.payload,
      }
    case types.SET_IN_VIEW_COURSE:
      return {
        ...state,
        inViewCourse: action.inViewCourse,
      }
    case types.SET_COURSE_PROMOTED:
      return {
        ...state,
        promote: action.payload,
      }
    case types.SET_ALL_LANGUAGES_PROMOTED:
      return {
        ...state,
        allLanguagesPromoted: action.payload,
      }
    case types.SET_TABLE_DATA:
      return {
        ...state,
        tableData: action.payload,
      }
    case types.SET_ENROLLMENT_TYPE:
      return {
        ...state,
        enrollmentType: action.payload,
      }
    case types.SET_NEW_ACCESS_CODE:
      return {
        ...state,
        newAccessCode: action.payload,
      }
    case types.SET_ENROLLMENT_PERIOD_TYPE:
      return {
        ...state,
        enrollmentPeriodType: action.payload,
      }
    case types.SET_ENROLLMENT_PERIOD:
      return {
        ...state,
        enrollmentPeriod: action.payload,
      }
    case types.SET_PRICE:
      return {
        ...state,
        price: action.payload,
      }

    case types.SET_HAS_GIVEN_FEEDBACK:
      return {
        ...state,
        hasGivenFeedBack: action.payload,
      }

    case types.SET_COMPLETED_TERMS:
      return {
        ...state,
        hasCompletedTerms: action.payload,
      }

    default:
      return state
  }
}

export default courseReducer
